import UAParser from 'ua-parser-js'

export const useDeviceType = () => {
  const parser = new UAParser()
  parser.setUA(navigator.userAgent)
  const deviceType = parser.getDevice().type || 'desktop'
  return { deviceType }
}
